import { useState } from 'react';
import { Card } from 'semantic-ui-react';
import styles from '../styles/Activity.module.scss';
import { useTranslation } from 'react-i18next';
import UserDateInput from '../UserDateInput';
import { ActivityInitialDataResponse } from '@components/Activity/types/ActivityInitialDataResponse';
import { PersonDTO } from '@behavior/inventories/dto/PersonDTO';

type Props = {
  initialData?: ActivityInitialDataResponse;
  hseUnit?: PersonDTO;
  setHseUnit?: (hseUnit?: PersonDTO) => void;
  signatureDate?: string;
  setSignatureDate?: (signatureDate?: string) => void;
  disabled?: boolean;
};

const HseUnitCard = ({
  initialData,
  hseUnit,
  setHseUnit,
  signatureDate,
  setSignatureDate,
  disabled,
}: Props) => {
  const { t } = useTranslation();
  const currentUser = initialData?.currentUser;
  const [userDateValidation, setUserDateValidation] = useState(0);
  const [userValueWithoutPersonalData, setUserValueWithoutPersonalData] = useState(hseUnit);

  const setDefaultUser = (clear: boolean) => {
    if (setHseUnit) {
      setHseUnit(clear ? undefined : currentUser);
    }
  };

  const updateUserDateFieldsValidation = (selectedOption?: PersonDTO) => {
    setUserDateValidation(userDateValidation + 1);
    if (setHseUnit) {
      setHseUnit(selectedOption);
    }
  };

  const updateDataField = (selectedOption: any) => {
    if (setSignatureDate) {
      setSignatureDate(selectedOption);
    }
  };

  const setFieldVal = (val: string, date: any) => {
    if (setSignatureDate) {
      setSignatureDate(date);
    }
  };

  return (
    <Card className={styles.cardText}>
      <div className={styles.basicDiv}>
        <div className={styles.flexContainerActivity}>
          <div className={styles.chemicalTextHeader}>
            {t('traceability.form.details.page.container.hse.unit')}
          </div>
        </div>
        <UserDateInput
          setDefaultUser={setDefaultUser}
          updateUserDateFieldsValidation={updateUserDateFieldsValidation}
          updateDataField={updateDataField}
          setFieldVal={setFieldVal}
          userVal={hseUnit}
          userValueWithoutPersonalData={userValueWithoutPersonalData}
          setUserValueWithoutPersonalData={setUserValueWithoutPersonalData}
          dteVal={signatureDate}
          nameUser="hseUnit"
          dteName="hseDate"
          disabled={disabled}
          isUserValRequired={false}
          isDateRequired={false}
        />
      </div>
    </Card>
  );
};

export default HseUnitCard;
